import AccordianItemRender from './components/AccordianItemRender';
import { useAccordianContext } from './context';

const AccordianContent: React.FunctionComponent = function () {
  const { accordianContentClassName, items } = useAccordianContext();
  return (
    <div className={accordianContentClassName}>
      {items.map((item) => (
        <AccordianItemRender item={item} key={item.id} />
      ))}
    </div>
  );
};

export default AccordianContent;
